import './App.css';
import SearchBar from "./home_page.jsx";

function App() {
  return <SearchBar />;
}
export default App;

